
/**

 * 路由配置 - 大数据模块

 * @module bigData

 * @description 定义了两个路由，分别指向大数据中心和大配置页面。

 * @property {Object} path - 路由路径

 * @property {Object} name - 路由名称，包含多语言列表

 * @property {Function} component - 异步加载的组件

 */

export default [
    {
        path: 'bigData',
        name: { list: ['产业大数据', '数据', '数据面板', '大数据中心'] },
        component: () => import('@/views/bigData/index.vue')
    },
    {
        path: "/bigDataPage",
        name: { list: ['产业大数据', '数据', '数据面板', '大数据配置'] },
        component: () => import("@/views/bigDataDecoration/views/list.vue"),
    },
]
